import { Lightbulb, X } from 'lucide-react';
import { useState } from 'react';

export function QuickTipBanner() {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="bg-[#FEF9E7] border border-[#F4D03F] rounded-lg p-4 flex items-start gap-3">
      <div className="w-8 h-8 rounded-full bg-[#F4D03F] flex items-center justify-center flex-shrink-0">
        <Lightbulb size={18} className="text-[#1B365D]" />
      </div>
      <div className="flex-1">
        <div className="text-[14px] font-semibold text-[#1B365D] mb-1">
          Quick Tip: Save receipts digitally
        </div>
        <div className="text-[13px] text-[#4A5568]">
          Forward receipt emails to your inbox address and we'll automatically create expense drafts for you to review.
        </div>
      </div>
      <button onClick={() => setIsVisible(false)} className="text-[#718096] hover:text-[#4A5568]">
        <X size={18} />
      </button>
    </div>
  );
}
